import { render } from "./DataMapperStreaming.vue?vue&type=template&id=39c14d2c&scoped=true"
import script from "./DataMapperStreaming.vue?vue&type=script&lang=js"
export * from "./DataMapperStreaming.vue?vue&type=script&lang=js"

import "./DataMapperStreaming.vue?vue&type=style&index=0&id=39c14d2c&lang=scss&scoped=true"
import "./DataMapperStreaming.vue?vue&type=style&index=1&id=39c14d2c&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39c14d2c"]])

export default __exports__